module.exports = __webpack_public_path__ + "static/media/psn.a741329e.png";